import {Injectable, Inject} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {APP_CONFIG, IAppConfig} from '../app.config';

@Injectable()
export class FileService {
  private _token: string= localStorage.getItem('token');

  constructor(
      private http: Http,
      @Inject(APP_CONFIG) private config: IAppConfig
  ) { }

  uploadFile(body: any) {
      const token = this._token;
      const headers = new Headers({'Authorization': token});
      const formData = new FormData();
      formData.append('file', body.file);
      formData.append('attachableId', body.attachableId);
      formData.append('attachableType', body.attachableType);
      return this.http.post(this.config.apiEndpoint + 'file-upload', formData, {
          headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  uploadRequestedFile(body: any) {
      const formData = new FormData();
      formData.append('file', body.file);
      formData.append('token', body.token);
      return this.http.post(this.config.apiEndpoint + 'requested-file-upload', formData)
      .catch(this.handleErrorObservable);
  }

  getFileRequestInfo(doctoken: string) {
      const token = this._token;
      const headers = new Headers({'Authorization': token});
      return this.http.get(this.config.apiEndpoint + 'request-document/info/'+encodeURIComponent(doctoken), {
          headers: headers
      }).map((res)=>{
          if(res.status==200) {
            return res.json();
          }
      });
  }

  deleteFile(body: Object) {
      const token = this._token;
      const headers = new Headers({ 'Authorization': token });
      const options = new RequestOptions({ headers: headers });
      return this.http.post(this.config.apiEndpoint + '/api/fileDelete', body, options )
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
  }

  fileProfileUpload(body: any) {
    const token = this._token;
    const headers = new Headers({'Authorization': token});
    const formData = new FormData();
    formData.append('file', body.file);
    return this.http.post(this.config.apiEndpoint + 'fileProfileUpload', formData, {
      headers: headers
    })
    .catch(this.handleErrorObservable);
  }

  insertProfileData$(body: Object) {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint + 'insert-profile-data', body, options )
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }

  updateProfileUpload$(body: Object) {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint + 'update-profile-upload', body, options )
    .map((res: Response) => res.json())
    .catch(this.handleErrorObservable);
  }


  getApplications$(): Observable<any> {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'applications/get-applications-details', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  getProfileUpload$() {
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'get-ProfileUpload', options).map((res => res.json()))
    .catch(this.handleErrorObservable);
  }

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || error.json() || 'Server Error' );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/file.service.ts